module.exports = __webpack_public_path__ + "static/DeSproelberch-cca8541fd4cafd725749333cc93fa8ec.jpg";